package pl.finn.forms.utils.model

import io.kvision.form.check.CheckBox
import io.kvision.html.ButtonStyle
import io.kvision.html.Div
import io.kvision.html.button
import io.kvision.panel.SimplePanel
import pl.finn.forms.tw17.*
import pl.finn.forms.tw1.DocumentTreeNode
import pl.finn.forms.utils.Components
import pl.finn.forms.utils.FormReadingUtils
import pl.finn.forms.utils.form.FormBuilder
import pl.finn.forms.utils.form.FormElement

class Person17(reference: FormBuilder<DocumentTreeNode>) {

  private val formReference = reference
  private val components = Components(formReference)
  val address = Addresses17(formReference)

  fun createInnyNrId(nrIdentyfikacyjny: NrIdentyfikacyjny, isNrId: DocumentTreeNode): ArrayList<Any> {
        val finnId = "collapseFinn_" + Util.getRandomString()
    val obligated = ArrayList<Any>()
    val inne = ArrayList<Any>()
    inne.add(
      components.createInput(
        nrIdentyfikacyjny.innyNrId,
        "Inny numer identyfikacyjny"
      )
    )
    inne.add(
      components.createInput(
        nrIdentyfikacyjny.rodzaj,
        "Rodzaj innego numeru identyfikacyjnego"
      )
    )

    val collapsedNPDiv = Div(className = "collapse") { id = finnId }

    val collapseObligated = components.createCollapseCheckbox(
      isNrId,
      "Rodzaj innego numeru identyfikacyjnego",
      finnId,
      inne,
      collapsedNPDiv
    )
    obligated.add(collapseObligated)
    components.changeElementChildrenStatus(
      inne,
      (collapseObligated.field as CheckBox).value
    )
    obligated.add(collapsedNPDiv)
    obligated.add(inne)
    return obligated
  }

  fun createNaturalPerson(osobaFizyczna: OsobaFizyczna, typeData: String, legend: String, isNotMalzonek: Boolean = true): ArrayList<Any> {
    val naturalPerson = ArrayList<Any>()
    naturalPerson.add(
      components.createFieldset(
        legend
      )
    )
    val naturalPersonData = ArrayList<Any>()
    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.imie,
        "Imię"
      )
    )
    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.nazwisko,
        "Nazwisko"
      )
    )
    if (typeData == "Normal" || typeData == "Long") {
      naturalPersonData.add(
        components.createInput(
          osobaFizyczna.imieMatki,
          "Imię matki zobowiązanego",
          isRequired = false
        )
      )
      naturalPersonData.add(
        components.createInput(
          osobaFizyczna.imieOjca,
          "Imię ojca zobowiązanego",
          isRequired = false
        )
      )
    }
    val identityMap = HashMap<String, Any?>()
    identityMap["0"] = components.createInput(
      osobaFizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    identityMap["1"] = components.createInput(
      osobaFizyczna.pesel,
      "PESEL",
      requirements = FormReadingUtils.checkValidation("TNrPESEL")
    )
    identityMap["2"] = components.createInput(
      osobaFizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityMap["3"] = components.createCheckbox(
      osobaFizyczna.oswiadczenieWierzyciela,
      Tw17Data.statement,
      true
    )
    naturalPersonData.add(
      components.createRadioGroup(
        osobaFizyczna.admId,
        "Identyfikator administracyjny",
        Tw17Data.optionsOfOIdentity,
        identityMap
      )
    )
    naturalPersonData.add(identityMap)

    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.nrInny,
        "Numer, za pomocą którego zobowiązany został zidentyfikowany na potrzeby podatku w innym kraju",
        isRequired = false
      )
    )
    naturalPersonData.addAll(
      createInnyNrId(
        osobaFizyczna.nrIdentyfikacyjny,
        osobaFizyczna.posiadaNrId
      )
    )

    if (typeData == "Normal" || typeData == "Long") {
      naturalPersonData.addAll(
        address.createAddress(
          osobaFizyczna.adres,
          osobaFizyczna.adresData
        )
      )
    }
    if (typeData == "Long") {
      naturalPersonData.add(
        components.createDateTime(
          osobaFizyczna.dataUrodzenia,
          "Data urodzenia zobowiązanego",
          tooltipMessage = "Po zaznaczeniu check-box „<b>Oświadczenie wierzyciela</b>” pole „<b>Data urodzenia zobowiązanego</b>” jest polem obowiązkowym do wypełnienia.",
          isRequired = false
        )
      )
      if (isNotMalzonek) {
        naturalPersonData.add(
          components.createSelect(
            osobaFizyczna.odpowiedzialnosc,
            "Rodzaj odpowiedzialności zobowiązanego w stosunku do wskazanego podmiotu, u którego wystąpiło zobowiązanie",
            Tw17Data.listOfResponsibilityTypes
          )
        )
      }
    }
    naturalPerson.add(naturalPersonData)
    return naturalPerson
  }

  fun createNaturalPersonZalacznik(osobaFizyczna: OsobaFizyczna): ArrayList<Any> {
    val naturalPerson = ArrayList<Any>()
    naturalPerson.add(
      components.createFieldset(
        "Osoba fizyczna"
      )
    )
    val naturalPersonData = ArrayList<Any>()
    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.imie,
        "Imię"
      )
    )
    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.nazwisko,
        "Nazwisko"
      )
    )
    val identityMap = HashMap<String, Any?>()
    identityMap["0"] = components.createInput(
      osobaFizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    identityMap["1"] = components.createInput(
      osobaFizyczna.pesel,
      "PESEL",
      requirements = FormReadingUtils.checkValidation("TNrPESEL")
    )
    identityMap["2"] = components.createInput(
      osobaFizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityMap["3"] = components.createCheckbox(
      osobaFizyczna.oswiadczenieWierzyciela,
      Tw17Data.statement,
      true
    )
    naturalPersonData.add(
      components.createRadioGroup(
        osobaFizyczna.admId,
        "Identyfikator administracyjny",
        Tw17Data.optionsOfOIdentity,
        identityMap
      )
    )
    naturalPersonData.add(identityMap)
    naturalPersonData.addAll(
      address.createAddress(
        osobaFizyczna.adres,
        osobaFizyczna.adresData
      )
    )

    naturalPersonData.addAll(
      createInnyNrId(
        osobaFizyczna.nrIdentyfikacyjny,
        osobaFizyczna.posiadaNrId
      )
    )
    naturalPerson.add(naturalPersonData)
    return naturalPerson
  }

  fun createNaturalPersonWspolnik(osobaFizyczna: OsobaFizyczna, typeData: String, legend: String): ArrayList<Any> {
    val naturalPerson = ArrayList<Any>()
    naturalPerson.add(
      components.createFieldset(
        legend
      )
    )
    val naturalPersonData = ArrayList<Any>()
    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.imie,
        "Imię"
      )
    )
    naturalPersonData.add(
      components.createInput(
        osobaFizyczna.nazwisko,
        "Nazwisko"
      )
    )
    val identityMap = HashMap<String, Any?>()
    identityMap["0"] = components.createInput(
      osobaFizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    identityMap["1"] = components.createInput(
      osobaFizyczna.pesel,
      "PESEL",
      requirements = FormReadingUtils.checkValidation("TNrPESEL")
    )
    identityMap["2"] = components.createInput(
      osobaFizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityMap["3"] = components.createCheckbox(
      osobaFizyczna.oswiadczenieWierzyciela,
      Tw17Data.statement,
      true
    )
    naturalPersonData.add(
      components.createRadioGroup(
        osobaFizyczna.admId,
        "Identyfikator administracyjny",
        Tw17Data.optionsOfOIdentity,
        identityMap
      )
    )
    naturalPersonData.add(identityMap)

    if (typeData == "Normal" || typeData == "Long") {
      naturalPersonData.addAll(
        address.createAddress(
          osobaFizyczna.adres,
          osobaFizyczna.adresData
        )
      )
    }
    naturalPerson.add(naturalPersonData)
    return naturalPerson
  }

  fun createNonPhysicalPerson(osobaNiefizyczna: OsobaNiefizyczna, typeData: String, type: String, isOswiadzenieWierzyciela: Boolean): ArrayList<Any> {
    val nonPhysicalPerson = ArrayList<Any>()
    nonPhysicalPerson.add(
      components.createFieldset(
        type
      )
    )
    val nonPhysicalPersonData = ArrayList<Any>()
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nazwa,
        "Nazwa podmiotu"
      )
    )
    val identityNonPhysicalMap = HashMap<String, Any?>()
    identityNonPhysicalMap["0"] = components.createInput(
      osobaNiefizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityNonPhysicalMap["1"] = components.createInput(
      osobaNiefizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    if (isOswiadzenieWierzyciela) {
      identityNonPhysicalMap["2"] = components.createCheckbox(
      osobaNiefizyczna.oswiadczenie,
      Tw17Data.statement,
      true
    )
    }
    nonPhysicalPersonData.add(
      components.createRadioGroup(
        osobaNiefizyczna.admId,
        "Identyfikator administracyjny",
        if (isOswiadzenieWierzyciela) Tw17Data.optionsOfOIdentityNonPhysical else Tw17Data.optionsOfOIdentityNonPhysicalWithoutOswiadczenie,
        identityNonPhysicalMap
      )
    )
    nonPhysicalPersonData.add(identityNonPhysicalMap)

    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.krs,
        "Numer KRS",
        isRequired = false,
        requirements = FormReadingUtils.checkValidation("TNrKRS")
      )
    )

    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nrInny,
        "Numer, za pomocą którego zobowiązany został zidentyfikowany na potrzeby podatku w innym kraju",
        isRequired = false
      )
    )
    nonPhysicalPersonData.addAll(
      createInnyNrId(
        osobaNiefizyczna.nrIdentyfikacyjny,
        osobaNiefizyczna.posiadaNrId
      )
    )
    if (typeData == "Medium" || typeData == "Long") {
      nonPhysicalPersonData.addAll(
        address.createAddress(
          osobaNiefizyczna.adres,
          osobaNiefizyczna.adresData
        )
      )
    }
    if (typeData == "Long") {
      nonPhysicalPersonData.add(
        components.createSelect(
          osobaNiefizyczna.odpowiedzialnosc,
          "Rodzaj odpowiedzialności zobowiązanego w stosunku do wskazanego podmiotu, u którego wystąpiło zobowiązanie",
          Tw17Data.listOfResponsibilityTypes
        )
      )
    }
    nonPhysicalPerson.add(nonPhysicalPersonData)
    return nonPhysicalPerson
  }

  fun createNonPhysicalPersonZalacznik(osobaNiefizyczna: OsobaNiefizyczna): ArrayList<Any> {
    val nonPhysicalPerson = ArrayList<Any>()
    nonPhysicalPerson.add(
      components.createFieldset(
        "Podmiot niebędący osobą fizyczną"
      )
    )
    val nonPhysicalPersonData = ArrayList<Any>()
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nazwa,
        "Nazwa podmiotu"
      )
    )
    val identityNonPhysicalMap = HashMap<String, Any?>()
    identityNonPhysicalMap["0"] = components.createInput(
      osobaNiefizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityNonPhysicalMap["1"] = components.createInput(
      osobaNiefizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    identityNonPhysicalMap["2"] = components.createCheckbox(
      osobaNiefizyczna.oswiadczenie,
      Tw17Data.statement,
      true
    )
    nonPhysicalPersonData.add(
      components.createRadioGroup(
        osobaNiefizyczna.admId,
        "Identyfikator administracyjny",
        Tw17Data.optionsOfOIdentityNonPhysical,
        identityNonPhysicalMap
      )
    )
    nonPhysicalPersonData.add(identityNonPhysicalMap)

    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.krs,
        "Numer KRS",
        isRequired = false,
        requirements = FormReadingUtils.checkValidation("TNrKRS")
      )
    )
    nonPhysicalPersonData.addAll(
      address.createAddress(
        osobaNiefizyczna.adres,
        osobaNiefizyczna.adresData
      )
    )
    nonPhysicalPersonData.addAll(
      createInnyNrId(
        osobaNiefizyczna.nrIdentyfikacyjny,
        osobaNiefizyczna.posiadaNrId
      )
    )
    nonPhysicalPerson.add(nonPhysicalPersonData)
    return nonPhysicalPerson
  }

  fun createNonPhysicalPersonWspolnik(osobaNiefizyczna: OsobaNiefizyczna, typeData: String, type: String): ArrayList<Any> {
    val nonPhysicalPerson = ArrayList<Any>()
    nonPhysicalPerson.add(
      components.createFieldset(
        type
      )
    )
    val nonPhysicalPersonData = ArrayList<Any>()
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nazwa,
        "Nazwa podmiotu"
      )
    )
    val identityNonPhysicalMap = HashMap<String, Any?>()
    identityNonPhysicalMap["0"] = components.createInput(
      osobaNiefizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityNonPhysicalMap["1"] = components.createInput(
      osobaNiefizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    identityNonPhysicalMap["2"] = components.createCheckbox(
      osobaNiefizyczna.oswiadczenie,
      Tw17Data.statement,
      true
    )
    nonPhysicalPersonData.add(
      components.createRadioGroup(
        osobaNiefizyczna.admId,
        "Identyfikator administracyjny",
        Tw17Data.optionsOfOIdentityNonPhysical,
        identityNonPhysicalMap
      )
    )
    nonPhysicalPersonData.add(identityNonPhysicalMap)

    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.krs,
        "Numer KRS",
        isRequired = false,
        requirements = FormReadingUtils.checkValidation("TNrKRS")
      )
    )

    if (typeData == "Medium" || typeData == "Long") {
      nonPhysicalPersonData.addAll(
        address.createAddress(
          osobaNiefizyczna.adres,
          osobaNiefizyczna.adresData
        )
      )
    }
    nonPhysicalPerson.add(nonPhysicalPersonData)
    return nonPhysicalPerson
  }

  fun createNonPhysicalPodmiot(osobaNiefizyczna: PodmiotWOrganizacji, typeData: String): ArrayList<Any> {
    val nonPhysicalPerson = ArrayList<Any>()
    nonPhysicalPerson.add(
      components.createFieldset(
        "Podmiot w organizacji"
      )
    )
    val nonPhysicalPersonData = ArrayList<Any>()
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nazwa,
        "Nazwa podmiotu"
      )
    )
    if (typeData == "Medium" || typeData == "Long") {
      nonPhysicalPersonData.addAll(
        address.createAddress(
          osobaNiefizyczna.adres,
          osobaNiefizyczna.adresData
        )
      )
      nonPhysicalPersonData.add(
        components.createSelect(
          osobaNiefizyczna.odpowiedzialnosc,
          "Rodzaj odpowiedzialności zobowiązanego w stosunku do wskazanego podmiotu, u którego wystąpiło zobowiązanie",
          Tw17Data.listOfResponsibilityTypes
        )
      )
    }
    nonPhysicalPerson.add(nonPhysicalPersonData)
    return nonPhysicalPerson
  }

  fun createNonPhysicalPrzedsiebiorstwoWSpadku(osobaNiefizyczna: PrzedsiebiorstwoWSpadku, typeData: String): ArrayList<Any> {
    val nonPhysicalPerson = ArrayList<Any>()
    nonPhysicalPerson.add(
      components.createFieldset(
        "Przedsiębiorstwo w spadku"
      )
    )
    val nonPhysicalPersonData = ArrayList<Any>()
    nonPhysicalPersonData.add(
      components.createCheckbox(
        osobaNiefizyczna.wSpadku,
        Tw17Data.inDecline,
        isRequired = false
      )
    )
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.imie,
        "Imię"
      )
    )
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nazwisko,
        "Nazwisko"
      )
    )
    nonPhysicalPersonData.add(
      components.createInput(
        osobaNiefizyczna.nazwa,
        "Nazwa podmiotu"
      )
    )
    val identityNonPhysicalMap = HashMap<String, Any?>()
    identityNonPhysicalMap["0"] = components.createInput(
      osobaNiefizyczna.regon,
      "REGON",
      requirements = FormReadingUtils.checkValidation("TNrREGON")
    )
    identityNonPhysicalMap["1"] = components.createInput(
      osobaNiefizyczna.nip,
      "NIP",
      requirements = FormReadingUtils.checkValidation("TNrNIP")
    )
    nonPhysicalPersonData.add(
      components.createRadioGroup(
        osobaNiefizyczna.admId,
        "Identyfikator administracyjny",
        Tw17Data.optionsOfOIdentityNonPhysicalWithoutOswiadczenie,
        identityNonPhysicalMap
      )
    )
    nonPhysicalPersonData.add(identityNonPhysicalMap)

    if (typeData == "Medium" || typeData == "Long") {
      nonPhysicalPersonData.addAll(
        address.createAddress(
          osobaNiefizyczna.adres,
          osobaNiefizyczna.adresData
        )
      )
    }
    nonPhysicalPerson.add(nonPhysicalPersonData)
    return nonPhysicalPerson
  }

  fun createdObligatedPersons(documentTreeNode: DocumentTreeNode, zobowiazaniPierwotni: ArrayList<ZobowiazanyPierwotny>): ArrayList<Any> {
    val finnId = "collapseFinn_" + Util.getRandomString()
    val obligated = ArrayList<Any>()
    val collapsedNPDiv = Div(className = "collapse") { id = finnId }
    val obligatedPersons = createObligatedPersonsList(zobowiazaniPierwotni)
    val collapseObligated = components.createCollapseCheckbox(
      documentTreeNode,
      "Dane zobowiązanych, u których powstał obowiązek",
      finnId,
      obligatedPersons,
      collapsedNPDiv
    )
    obligated.add(collapseObligated)
    components.changeElementChildrenStatus(
      obligatedPersons,
      (collapseObligated.field as CheckBox).value
    )
    obligated.add(collapsedNPDiv)
    obligated.add(obligatedPersons)
    return obligated
  }

  private fun createObligatedPersonsList(zobowiazaniPierwotni: ArrayList<ZobowiazanyPierwotny>): ArrayList<Any> {
    val finnId = "collapseFinn_" + Util.getRandomString()
    val div = Div() { id = finnId }
    val ObligatedPersonsDiv = ArrayList<Any>()
    val ObligatedPersonsList = ArrayList<Any>()

    if(zobowiazaniPierwotni.isEmpty()){//todo czy potrzebne
      zobowiazaniPierwotni.add(ZobowiazanyPierwotny())
    }

    zobowiazaniPierwotni.forEach {
      ObligatedPersonsList.add(
        createObligatedPersonsElement(it)
      )
    }

    ObligatedPersonsDiv.add(div)
    ObligatedPersonsDiv.add(arrayListOf(
      ObligatedPersonsList,
      createObligatedPersonsButtons(zobowiazaniPierwotni, div)
    ))
    return ObligatedPersonsDiv
  }

  private fun createObligatedPersonsElement(zobowiazanyPierwotny: ZobowiazanyPierwotny): ArrayList<Any> {
    val obligatedPerson = ArrayList<Any>()
    val primaryObligatedMap = HashMap<String, Any?>()
    val naturalPersonPrimary =
      createNaturalPerson(
        zobowiazanyPierwotny.osobaFizyczna,
        "Short", "Osoba fizyczna"
      )
    val spouses = ArrayList<Any>()
    spouses.add(
      components.createFieldset(
        "Małżonkowie odpowiedzialni solidarnie"
      )
    )
    val spousesArray = ArrayList<Any>()
    spousesArray.add(
      createNaturalPerson(
        zobowiazanyPierwotny.malzonkowie[0],
        "Short",
        "Zestaw danych identyfikacyjnych małżonka solidarnego"
      )
    )
    spousesArray.add(
      createNaturalPerson(
        zobowiazanyPierwotny.malzonkowie[1],
        "Short",
        "Zestaw danych identyfikacyjnych małżonka solidarnego"
      )
    )
    spouses.add(spousesArray)


    val nonPhysicalPersonPrimary = createNonPhysicalPerson(
      zobowiazanyPierwotny.osobaPrawna,
      "Short",
      "Osoba prawna",
      true
    )
    val nonPhysicalJednostkaPrimary = createNonPhysicalPerson(
      zobowiazanyPierwotny.osobaJednostka,
      "Short",
      "Jednostka organizacyjna niebędąca osobą prawną",
      true
    )
    val nonPhysicalPersonPodmiot = ArrayList<Any>()
    nonPhysicalPersonPodmiot.add(
      components.createInput(
        zobowiazanyPierwotny.podmiot.nazwa,
        "Nazwa podmiotu"
      )
    )

    val nonPhysicalPodmiotPrimary = nonPhysicalPersonPodmiot
    primaryObligatedMap["0"] = naturalPersonPrimary
    primaryObligatedMap["1"] = spouses
    primaryObligatedMap["2"] = nonPhysicalPersonPrimary
    primaryObligatedMap["3"] = nonPhysicalJednostkaPrimary
    primaryObligatedMap["4"] = nonPhysicalPodmiotPrimary
    val obligatedRadio = components.createRadioGroup(
      zobowiazanyPierwotny.obligated,
      "Zobowiązany",
      Tw17Data.optionsOfPierwotnyObligated,
      primaryObligatedMap
    )
    obligatedPerson.add(obligatedRadio)
    obligatedPerson.add(primaryObligatedMap)

    return obligatedPerson
  }

  private fun createObligatedPersonsButtons(zobowiazaniPierwotni: ArrayList<ZobowiazanyPierwotny>, div: Div): Div {
    return (
      Div(className = "p-2 d-flow-root") {
        if (zobowiazaniPierwotni.size > 1) {
          button(
            "Usuń",
            "far fa-minus-square",
            ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
          ).onClick {

            zobowiazaniPierwotni.removeAt(zobowiazaniPierwotni.lastIndex)
            val newBudgetImplementationsList = ArrayList<Any>()
            zobowiazaniPierwotni.forEach {
              newBudgetImplementationsList.add(
                createObligatedPersonsElement(it)
              )
            }
            div.removeAll()
            components.readComponentsList(newBudgetImplementationsList, div)
            components.readComponentsList(createObligatedPersonsButtons(zobowiazaniPierwotni, div), div)
          }

        }
        button(
          "Dodaj",
          "far fa-plus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
        ).onClick {

          zobowiazaniPierwotni.add(ZobowiazanyPierwotny())
          val newBudgetImplementationsList = ArrayList<Any>()
          zobowiazaniPierwotni.forEach {
            newBudgetImplementationsList.add(
              createObligatedPersonsElement(it)
            )
          }
          div.removeAll()
          components.readComponentsList(newBudgetImplementationsList, div)
          components.readComponentsList(createObligatedPersonsButtons(zobowiazaniPierwotni, div), div)
        }
      }
    )


  }

  fun createPartners(documentTreeNode: DocumentTreeNode, wspolnik: ArrayList<Wspolnik>): ArrayList<Any> {
    val finnId = "collapseFinn_" + Util.getRandomString()
    val partner = ArrayList<Any>()
    val obligatedPartner = ArrayList<Any>()

    wspolnik.forEach {
      obligatedPartner.add(createNewPartner(it))
    }

    val collapsedNPDiv = Div(className = "collapse") { id = finnId }

    val collapsePerson = components.createCollapseCheckbox(
      documentTreeNode,
      "Dane wspólników spółki nieposiadającej osobowości prawnej",
      finnId,
      obligatedPartner,
      collapsedNPDiv
    )
    partner.add(collapsePerson)
    components.changeElementChildrenStatus(
      obligatedPartner,
      (collapsePerson.field as CheckBox).value
    )
    components.readComponentsList(obligatedPartner, collapsedNPDiv)
    components.readComponentsList(createButtonGroup(documentTreeNode, wspolnik, collapsedNPDiv), collapsedNPDiv)
    partner.add(collapsedNPDiv)
    return partner
  }

  private fun createNewPartner(it: Wspolnik): ArrayList<Any> {
    val partner = ArrayList<Any>()
    val primaryObligatedMap = HashMap<String, Any?>()
    val naturalPartner =
      createNaturalPersonWspolnik(
        it.osobaFizyczna,
        "Normal",
        "Osoba fizyczna"
      )
    val nonPhysicalPartner = createNonPhysicalPersonWspolnik(
      it.osobaNiefizyczna,
      "Medium",
      "Podmiot niebędący osobą fizyczną"
    )
    primaryObligatedMap["0"] = naturalPartner
    primaryObligatedMap["1"] = nonPhysicalPartner
    partner.add(
      components.createRadioGroup(
        it.partner,
        "Wspólnik",
        Tw17Data.optionsOfPrimalObligated,
        primaryObligatedMap
      )
    )
    partner.add(primaryObligatedMap)
    return partner
  }

  fun createSubject(namespaceURI: String?, podmiot: Podmiot): ArrayList<Any> {
    val subject = ArrayList<Any>()
    subject.add(
      components.createInput(
        podmiot.nazwa,
        "Nazwa organu"
      )
    )
    subject.add(
      address.createAddress(
        podmiot.adres,
        podmiot.adresData
      )
    )
    subject.add(
      components.createInput(
        podmiot.nrTelefonu,
        "Numer telefonu",
        requirements = FormReadingUtils.checkValidation("TNrTelefonu"),
        isRequired = false
      )
    )
    subject.add(
      components.createInput(
        podmiot.nrTelefonuWew,
        "Numer wewnętrzny",
        isRequired = false
      )
    )
    subject.add(
      components.createInput(
        podmiot.email,
        "Adres e-mail",
        requirements = FormReadingUtils.checkValidation("TAdresEmail"),
        isRequired = false
      )
    )
    subject.add(
      components.createInput(
        podmiot.skrytkaEPuap,
        "Adres skrzynki ePUAP",
        requirements =
        FormReadingUtils.checkValidation("TSkrytkaEPuap"), //???
        isRequired = false
        )
    )
    subject.add(
      components.createInput(
        podmiot.adresEdorecznen,
        "Adres do e-Doręczeń",
        requirements =
          FormReadingUtils.checkValidation("TEdoreczenia"),
          isRequired = false
      )
    )
    return subject
  }

  fun createButtonGroup(
    documentTreeNode: DocumentTreeNode,
    parentElements: ArrayList<Wspolnik>,
    div: Div
  ): Div {
    return (
        Div(className = "p-2 d-flow-root") {
          if (parentElements.size > 1) {
            button(
              "Usuń",
              "far fa-minus-square",
              ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
            ).onClick {
              formReference.getData()

              formReference.form.remove(parentElements.get(parentElements.lastIndex).partner)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adres)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.admId)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.imie)
              //formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.email)
              //formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.dataUrodzenia)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nazwisko)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nip)
              //formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nrTelefonu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.odpowiedzialnosc)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.oswiadczenieWierzyciela)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.pesel)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.kodPocztowy)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.nrDomu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.nrLokalu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.ulica)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.gmina)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.miejscowosc)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.kodPocztowy)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.wojewodztwo)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.powiat)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyKodKraju)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyKodPocztowy)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyMiejscowosc)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyNrDomu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyNrLokalu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyUlica)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.admId)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adres)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nip)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nazwa)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.odpowiedzialnosc)
              //formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.oswiadczenie)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.regon)
              //formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.wSpadku)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.kodPocztowy)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.nrDomu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.nrLokalu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.ulica)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.gmina)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.miejscowosc)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.kodPocztowy)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.wojewodztwo)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.powiat)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyKodKraju)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyKodPocztowy)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyMiejscowosc)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyNrDomu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyNrLokalu)
              formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyUlica)
              parentElements.removeAt(parentElements.lastIndex)

              div.removeAll()

              val obligatedPartner = ArrayList<Any>()

              parentElements.forEach {
                obligatedPartner.add(createNewPartner(it))
              }

              val collapsePerson = div.id?.let { it1 ->
                components.createCollapseCheckbox(
                  documentTreeNode,
                  "Dane wspólników spółki nieposiadającej osobowości prawnej",
                  it1,
                  obligatedPartner,
                  div
                )
              }
              components.changeElementChildrenStatus(
                obligatedPartner,
                (collapsePerson?.field as CheckBox).value
              )

              components.readComponentsList(obligatedPartner, div)
              components.readComponentsList(createButtonGroup(documentTreeNode, parentElements, div), div)
            }
          }
          button(
            "Dodaj",
            "far fa-plus-square",
            ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
          ).onClick {
            formReference.getData()
            parentElements.add(Wspolnik())
            div.removeAll()

            val obligatedPartner = ArrayList<Any>()

            parentElements.forEach {
              obligatedPartner.add(createNewPartner(it))
            }

            val collapsePerson = div.id?.let { it1 ->
              components.createCollapseCheckbox(
                documentTreeNode,
                "Dane wspólników spółki nieposiadającej osobowości prawnej",
                it1,
                obligatedPartner,
                div
              )
            }
            components.changeElementChildrenStatus(
              obligatedPartner,
              (collapsePerson?.field as CheckBox).value
            )

            components.readComponentsList(obligatedPartner, div)
            components.readComponentsList(createButtonGroup(documentTreeNode, parentElements, div), div)
          }
        }
        )
  }

  fun createPositionsZalacznikPodmiot(pozycja: ArrayList<ZalacznikPodmitZobowiazany>): ArrayList<Any> {
    val finnId = "collapseFinn_" + Util.getRandomString()
    val div = Div() { id = finnId }
    val position = ArrayList<Any>()
    val positionData = ArrayList<Any>()

    pozycja.forEach {
      positionData.add(createZalacznikOsoba(it))
    }

    position.add(div)
    position.add(arrayListOf(
      positionData,
      createButtonGroup(pozycja, div),
    ))
    return position
  }

  fun createZalacznikOsoba(it: ZalacznikPodmitZobowiazany): ArrayList<Any> {
    val partner = ArrayList<Any>()
    val primaryObligatedMap = HashMap<String, Any?>()
    val naturalPartner =
      createNaturalPersonZalacznik(it.osobaFizyczna)
    val nonPhysicalPartner = createNonPhysicalPersonZalacznik(it.osobaNiefizyczna)
    primaryObligatedMap["0"] = naturalPartner
    primaryObligatedMap["1"] = nonPhysicalPartner
    partner.add(
      components.createRadioGroup(
        it.rodzaj,
        "Rodzaj podmiotu",
        Tw17Data.optionsOfPrimalObligated,
        primaryObligatedMap
      )
    )
    partner.add(primaryObligatedMap)
    return partner
  }

  fun createButtonGroup(
    parentElements: ArrayList<ZalacznikPodmitZobowiazany>,
    div: Div,
    //legend: String,
    //odsetki: Boolean
  ): Div {
    return (
            Div(className = "p-2 d-flow-root") {
              if (parentElements.size > 1) {
                button(
                  "Usuń",
                  "far fa-minus-square",
                  ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
                ).onClick {
                  formReference.getData()

                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.imie)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nazwisko)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.admId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nip)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.pesel)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.regon)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.oswiadczenieWierzyciela)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.posiadaNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nrIdentyfikacyjny.rodzaj)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nrIdentyfikacyjny.innyNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adres)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.kodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.miejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.ulica)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.nrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.nrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.wojewodztwo)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.powiat)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.gmina)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyKodKraju)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyKodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyMiejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyNrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyNrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyUlica)

                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nazwa)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.admId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nip)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.regon)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.krs)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.oswiadczenie)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.posiadaNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nrIdentyfikacyjny.rodzaj)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nrIdentyfikacyjny.innyNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adres)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.kodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.miejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.ulica)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.nrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.nrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.wojewodztwo)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.powiat)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.gmina)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyKodKraju)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyKodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyMiejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyNrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyNrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyUlica)
                  parentElements.removeAt(parentElements.lastIndex)
                  val partners = ArrayList<Any>()

                  parentElements.forEach {
                    partners.add(createZalacznikOsoba(it))
                  }
                  div.getChildren().forEach {
                    components.changeElementChildrenStatus(it, false)
                    (it as? SimplePanel?)?.hide()
                    formReference.remove(it)
                  }
                  div.removeAll()

                  components.readComponentsList(partners, div)
                  components.readComponentsList(createButtonGroup(parentElements, div), div)
                }
              }
              button(
                "Dodaj",
                "far fa-plus-square",
                ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
              ).onClick {
                formReference.getData()
                parentElements.add(ZalacznikPodmitZobowiazany())
                val partners = ArrayList<Any>()

                parentElements.forEach {
                  partners.add(createZalacznikOsoba(it))
                }

                div.removeAll()
                components.readComponentsList(partners, div)
                components.readComponentsList(createButtonGroup(parentElements, div), div)
              }
            }
            )
  }

  fun createPositionsZalacznikPodmiotMajatek(pozycja: ArrayList<ZalacznikPodmiotMajatkowy>): ArrayList<Any> {
    val finnId = "collapseFinn_" + Util.getRandomString()
    val div = Div() { id = finnId }
    val position = ArrayList<Any>()
    val positionData = ArrayList<Any>()

    pozycja.forEach {
      positionData.add(createZalacznikOsobaMajatek(it))
    }

    position.add(div)
    position.add(arrayListOf(
      positionData,
      createButtonGroupZalacznikPodmiotMajatek(pozycja, div),
    ))
    return position
  }

  fun createZalacznikOsobaMajatek(it: ZalacznikPodmiotMajatkowy): ArrayList<Any> {
    val partner = ArrayList<Any>()
    val primaryObligatedMap = HashMap<String, Any?>()
    val naturalPartner =
      createNaturalPersonZalacznik(it.osobaFizyczna)
    val nonPhysicalPartner = createNonPhysicalPersonZalacznik(it.osobaNiefizyczna)
    primaryObligatedMap["0"] = naturalPartner
    primaryObligatedMap["1"] = nonPhysicalPartner
    partner.add(
      components.createRadioGroup(
        it.rodzaj,
        "Rodzaj podmiotu",
        Tw17Data.optionsOfPrimalObligated,
        primaryObligatedMap
      )
    )
    partner.add(primaryObligatedMap)
    val majatekLabel = "Składnik majątku, do którego może być skierowana egzekucja"
    val firstMajetek = createAnAsset(it.majatekList, majatekLabel)
    val div2 = Div() { id = "anAsset3" }
    partner.add(div2)
    partner.add(
      arrayListOf(
        firstMajetek,
        createButtonAssetGroup(
          it.majatekList,
          div2,
          majatekLabel,
          "Dodaj kolejny składnik"
        )
      )
    )
    return partner
  }

  fun createButtonGroupZalacznikPodmiotMajatek(
    parentElements: ArrayList<ZalacznikPodmiotMajatkowy>,
    div: Div
  ): Div {
    return (
            Div(className = "p-2 d-flow-root") {
              if (parentElements.size > 1) {
                button(
                  "Usuń",
                  "far fa-minus-square",
                  ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
                ).onClick {
                  formReference.getData()

                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.imie)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nazwisko)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.admId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nip)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.pesel)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.regon)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.oswiadczenieWierzyciela)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.posiadaNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nrIdentyfikacyjny.rodzaj)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.nrIdentyfikacyjny.innyNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adres)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.kodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.miejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.ulica)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.nrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.nrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.wojewodztwo)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.powiat)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresPolski.gmina)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyKodKraju)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyKodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyMiejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyNrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyNrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaFizyczna.adresData.adresZagranicznyUlica)

                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nazwa)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.admId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nip)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.regon)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.krs)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.oswiadczenie)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.posiadaNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nrIdentyfikacyjny.rodzaj)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.nrIdentyfikacyjny.innyNrId)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adres)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.kodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.miejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.ulica)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.nrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.nrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.wojewodztwo)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.powiat)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresPolski.gmina)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyKodKraju)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyKodPocztowy)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyMiejscowosc)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyNrDomu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyNrLokalu)
                  formReference.form.remove(parentElements.get(parentElements.lastIndex).osobaNiefizyczna.adresData.adresZagranicznyUlica)
                    var counter = 0
                  parentElements.get(parentElements.lastIndex).majatekList.forEach { _ ->
                      formReference.form.remove(parentElements.get(parentElements.lastIndex).majatekList[counter])
                    counter++
                  }
                  parentElements.removeAt(parentElements.lastIndex)
                  val partners = ArrayList<Any>()

                  parentElements.forEach {
                    partners.add(createZalacznikOsobaMajatek(it))
                  }
                  div.getChildren().forEach {
                    components.changeElementChildrenStatus(it, false)
                    (it as? SimplePanel?)?.hide()
                    formReference.remove(it)
                  }
                  div.removeAll()

                  components.readComponentsList(partners, div)
                  components.readComponentsList(createButtonGroupZalacznikPodmiotMajatek(parentElements, div), div)
                }
              }
              button(
                "Dodaj",
                "far fa-plus-square",
                ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
              ).onClick {
                formReference.getData()
                parentElements.add(ZalacznikPodmiotMajatkowy())
                val partners = ArrayList<Any>()

                parentElements.forEach {
                  partners.add(createZalacznikOsobaMajatek(it))
                }

                div.removeAll()
                components.readComponentsList(partners, div)
                components.readComponentsList(createButtonGroupZalacznikPodmiotMajatek(parentElements, div), div)
              }
            }
            )
  }

  fun createAnAsset(assets: ArrayList<DocumentTreeNode>, label: String): ArrayList<FormElement> {
    val elements = ArrayList<FormElement>()
    assets.forEach {
      elements.add(components.createInput(it, label))
    }
    return elements
  }

  fun createButtonAssetGroup(parents: ArrayList<DocumentTreeNode>, div: Div, label: String, customNameButton: String? = null): Div {
    return Div(className = "p-2 d-flow-root") {
      if (parents.size > 1) {
        button(
          "Usuń",
          "far fa-minus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
        ).onClick {
          formReference.getData()

          formReference.form.remove(parents.get(parents.lastIndex))
          parents.removeAt(parents.lastIndex)
          val partners = createAnAsset(parents, label)
          div.removeAll()

          components.readComponentsList(partners, div)
          components.readComponentsList(createButtonAssetGroup(parents, div, label), div)
        }
      }
      val buttonName = customNameButton ?: "Dodaj"
      button(
        buttonName,
        "far fa-plus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
      ).onClick {
        formReference.getData()
        parents.add((DocumentTreeNode()))

        val partners = createAnAsset(parents, label)

        div.removeAll()
        components.readComponentsList(partners, div)
        components.readComponentsList(createButtonAssetGroup(parents, div, label), div)
      }
    }
  }

  fun createReminderDeliveryData(assets: ArrayList<DocumentTreeNode>, label: String): ArrayList<FormElement> {
    val elements = ArrayList<FormElement>()
    assets.forEach {
      elements.add(components.createDateTime(it, label))
    }
    return elements
  }

  fun createNrKonta(setData: DocumentTreeNode): FormElement {
    val bankAcoount = components.createInput(
      setData,
      "Numer rachunku bankowego beneficjenta",
      "CCAAAAAAAABBBBBBBBBBBBBBBB (26 cyfr)<br/> gdzie:<br/> CC to suma kontrolna (2 cyfry) <br/> AAAAAAAA to numer rozliczeniowy jednostki organizacyjnej banku (8 cyfr) <br/> BBBBBBBBBBBBBBBB to numer rachunku klienta w banku (16 cyfr). <br/><br/>",
      isRequired = true
    )
    bankAcoount.field.input.setAttribute("placeholder", "__ ____ ____ ____ ____ ____ ____")
    bankAcoount.field.input.setAttribute("data-slots", "_")
    bankAcoount.field.input.setAttribute("data-accept", "\\d")
    bankAcoount.field.input.setAttribute("size", "32")
    bankAcoount.field.input.setAttribute("onfocus", "FormUtils.applyDataMask(this);")
    return bankAcoount
  }

  fun createButtonReminderDeliveryDataGroup(parents: ArrayList<DocumentTreeNode>, div: Div, label: String): Div {
    return Div(className = "p-2 d-flow-root") {
      if (parents.size > 1) {
        button(
          "Usuń",
          "far fa-minus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
        ).onClick {
          formReference.getData()

          formReference.form.remove(parents.get(parents.lastIndex))
          parents.removeAt(parents.lastIndex)
          val partners = createReminderDeliveryData(parents, label)
          div.removeAll()

          components.readComponentsList(partners, div)
          components.readComponentsList(createButtonReminderDeliveryDataGroup(parents, div, label), div)
        }
      }
      button(
        "Dodaj",
        "far fa-plus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
      ).onClick {
        formReference.getData()
        parents.add((DocumentTreeNode()))

        val partners = createReminderDeliveryData(parents, label)

        div.removeAll()
        components.readComponentsList(partners, div)
        components.readComponentsList(createButtonReminderDeliveryDataGroup(parents, div, label), div)
      }
    }
  }
}
